<template>
	<div>
		<div class="flex items-center mb-5">
			<h2 class="text-dark-gray" v-if="12">
        Task List
      </h2>
      <div class="ml-6 flex items-center  mt-1">
        <vs-radio v-model="period" vs-value="day" class="mr-5"
          >Today</vs-radio
        >
        <vs-radio v-model="period" vs-value="week">this week</vs-radio>
      </div>
      <div class="ml-auto flex flex-nowrap">
        <span class="mr-3">Autopilot</span>
        <vs-switch v-model="autopilot" />
      </div>
		</div>
    <div>
      <vx-card class="mb-6">
        <div class="flex items-center justify-between -my-2 -mx-1">

          <div class="flex items-center mr-6 task-filter">
            <!-- <h6 class="mr-3 text-bold text-dark">Show only</h6> -->
            <span class="mr-3">Show only</span>
            <vs-checkbox v-model="filter.refare" class="mx-3">
              <span class="flex">
                <span class="mr-1">re-fare </span>
                <cat-task-list-filter-badge :badge="pendingTasksByActionType['refare']" />
              </span>
            </vs-checkbox>
            <vs-checkbox v-model="filter.priceDrop" class="mx-3">
              <span class="flex">
                <span class="mr-1">alert </span>
                <cat-task-list-filter-badge :badge="pendingTasksByActionType['priceDrop']" />
              </span>
            </vs-checkbox>
            <vs-checkbox v-model="filter.activate" class="mx-3">
              <span class="flex">
                <span class="mr-1">activate </span>
                <cat-task-list-filter-badge :badge="pendingTasksByActionType['activate']" />
              </span>
            </vs-checkbox>
            <vs-checkbox v-model="filter.reactivate" class="mx-3">
              <span class="flex">
                <span class="mr-1">re-activate </span>
                <cat-task-list-filter-badge :badge="pendingTasksByActionType['reactivate']" />
              </span>
            </vs-checkbox>
          </div>

          <div class="flex items-center Not-flex-grow ml-6" style="min-width:25%">
            <vs-input icon-no-border placeholder="Search customer" v-model="searchQuery" class="w-full" icon="icon-search" icon-pack="feather" />
          </div>

        </div>
      </vx-card>
    </div>
		<vs-row>
			<cat-task-results :results="sortedResults" v-if="results" :key="activeFiltersCount"/>
			<cat-search-spinner :loading="loading" v-else />
		</vs-row>
	</div>
</template>


<script>
import CatTaskResults from "@/components/cat/TaskResults.vue";
import CatSearchSpinner from '@/components/cat/SearchSpinner.vue';
import CatTaskListFilterBadge from "@/components/cat/TaskListFilterBadge.vue";

import Vue from 'vue'
import axios from '@/axios.js'
export default {
	components: {
		CatTaskResults,
    CatSearchSpinner,
    CatTaskListFilterBadge
	},
	data() {
		return {
      results: false,
      loading: true,
      period: 'day',
      filter: Vue.observable({
        refare: false,
        priceDrop: false,
        activate: false,
        reactivate: false
      }),
      searchQuery: '',
      autopilot: false
    };
	},
  created() {
    this.search()
  },
  methods: {
    search() {
      const that = this;
      that.loading = true;
      axios
        .post('/api/data-list/tasks', { hallo: "welt"})
        .then(function(resp) {
          that.results = resp.data.results;
        })
        .catch(function(err) {
          console.log('ERR', err);
        })
        .finally(() => {
          that.loading = false;
        });
    }
  },
  computed: {
    activeFiltersCount() {
      let that = this;
      return  Object.keys(this.filter).filter(f => that.filter[f]).length;
    },
    sortedResults() {
      let that = this,
          activeFilter = Object.keys(this.filter).filter(f => that.filter[f]);
      return this.results.filter(r => activeFilter.length == 0 || activeFilter.includes(r.actionType));
    },
    pendingTasksCount() {
      return (this.results || []).filter(r => r.status != 'done').length;
    },
    pendingTasksByActionType() {
      return (this.results || [])
        .filter(r=>r.status !='done')
        .reduce((accum, r) => {
            accum[r.actionType] = (accum[r.actionType] ? accum[r.actionType]+1 : 1);
            return accum; },
            {});
    }
  },
  watch: {
    pendingTasksCount(val) {
      console.log('PENDING TASKS #', val);
      this.$bus.$emit('pending-tasks-count', val);
    }
  }
};
</script>

<style lang="scss">
  .vs-input--placeholder {
    font-size: 1rem;
  }
</style>
